<template>
  <div class="user-center">
    <div class="content">
      <el-container>
        <el-container>
          <el-menu :default-active="$route.path"
                   class="el-menu-demo"
                   mode="horizontal"
                   text-color="#333333"
                   active-text-color="#fff"
                   :default-openeds="openeds"
                   router>
            <el-menu-item index="/home"
                          :route="{name:'home'}">首页</el-menu-item>
            <el-menu-item index="/shortTerm"
                          :route="{name:'shortTerm'}">短期招工</el-menu-item>
            <el-menu-item index="/highPay"
                          :route="{name:'highPay'}">高薪日结</el-menu-item>
            <el-menu-item index="/weekendPart"
                          :route="{name:'weekendPart'}">周末兼职</el-menu-item>
            <el-menu-item index="/inclusive"
                          :route="{name:'inclusive'}">食宿全包</el-menu-item>
            <el-menu-item index="/login"
                          :route="{name:'login'}">注册登录</el-menu-item>
            <el-menu-item index="/releaseInfo"
                          :route="{name:'releaseInfo'}">发布信息</el-menu-item>
            <el-menu-item index="/perCenter"
                          :route="{name:'perCenter'}">个人中心</el-menu-item>
          </el-menu>
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view> -->
        </el-container>
      </el-container>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'center',
  data () {
    return {
      activeIndex: '/home',
      openeds: ['/home']
    }
  },
}
</script>

<style scoped>
.content {
  width: 1120px;
  min-height: 550px;
  margin: 0 auto;
}
>>> .el-menu--horizontal > .el-menu-item.is-active {
  background: #e53631;
}
>>> .el-menu.el-menu--horizontal {
  border-bottom: solid 1px #e53631;
}
>>> .el-menu-item {
  width: 140px;
  text-align: center;
  font-size: 16px;
}
</style>